import * as React from 'react';
import { useGenericState } from 'src/library/UseGenericState';
import AuthHelper from './auth-helper';
import Loader from '../common/Loader';
import { logoutUser } from 'src/api/auth';

interface StateProps {
  isLoading?: boolean;
}

const Logout = () => {
  const [state, setState] = useGenericState<StateProps>({ });

  const handleLogout = async () => {
    setState({ isLoading: true });
    await logoutUser();
    setState({ isLoading: false });
    AuthHelper.logoutUser();
  };

  React.useEffect(() => {
    handleLogout();
  }, []);

  if (state.isLoading) {
    return <Loader />;
  }
  return <div />;
};

export default Logout;
